import initInstance from '@api/axios';

const api = initInstance('/file');

function stripContentDispositionQuotes(value: string) {
  return value.trim().replace(/^"(.*)"$/, '$1').replace(/^'(.*)'$/, '$1');
}

function decodeContentDispositionFilename(contentDisposition?: string) {
  if (!contentDisposition) {
    return undefined;
  }

  const encodedFilenameMatch = /filename\*\s*=\s*([^;]+)/i.exec(contentDisposition);

  if (encodedFilenameMatch?.[1]) {
    const encodedValue = stripContentDispositionQuotes(encodedFilenameMatch[1]);
    const encodedFilename = encodedValue.includes("''")
      ? encodedValue.split("''").slice(1).join("''")
      : encodedValue;

    try {
      return decodeURIComponent(encodedFilename);
    } catch (_error) {
      return encodedFilename;
    }
  }

  const filenameMatch = /filename\s*=\s*((['"]).*?\2|[^;\n]*)/i.exec(contentDisposition);

  if (filenameMatch?.[1]) {
    return stripContentDispositionQuotes(filenameMatch[1]);
  }

  return undefined;
}

const FileService = {
  links: {
    file: (hash: string) => api.getUri({ url: `/${hash}` }),
  },
  handleDownload: async (hash: string, onProgress: ((value: (((prevState: number) => number) | number)) => void)) => {
    const response = await api.get(`/${hash}`, {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
        onProgress(percentCompleted);
      }
    });
    const contentDisposition = response.headers['content-disposition'];
    const filename = decodeContentDispositionFilename(contentDisposition) || new Date().toDateString();
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');

    try {
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    } finally {
      link.parentNode?.removeChild(link);
      window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
    }
  }
};

export default FileService;
